// extracted by mini-css-extract-plugin
export default {"courseWrapper":"CourseIconsWrapper_courseWrapper__MgiOM","threeCoursesSpace":"CourseIconsWrapper_threeCoursesSpace__-rKIA"};